import { useEffect } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { useApi } from '@fortem-monorepo/react-spa'
import { Trades } from '@fortem-monorepo/web-sdk'

export const useSetInstrumentData = ({
  instrument_id,
  strategy_id,
}: {
  instrument_id?: number | null
  strategy_id?: number | null
}) => {
  const { setValue, getValues } = useFormContext<Trades.BookTradeBody>()

  const api = useApi()

  const instrumentDataQuery = useQuery({
    queryKey: ['trades/instrument-data', { instrument_id, strategy_id }],
    queryFn: () =>
      api.trades.getInfoFromInstrumentAndStrategy({
        instrument_id: instrument_id!,
        strategy_id: strategy_id!,
      }),
    enabled: !!instrument_id && !!strategy_id,
    retryOnMount: false,
  })

  const instrumentData = instrumentDataQuery.data

  useEffect(() => {
    if (instrumentData) {
      const { currency_id, unit_multiplier, structure_name } = instrumentData

      const values = getValues()

      const {
        currency_id: currentCurrencyId,
        unit_multiplier: currentUnitMultiplier,
        strategy_type: currentStrategyType,
      } = values

      if (currency_id && currency_id !== currentCurrencyId) {
        setValue('currency_id', currency_id, { shouldValidate: true })
      }
      if (unit_multiplier && unit_multiplier !== currentUnitMultiplier) {
        setValue('unit_multiplier', unit_multiplier, { shouldValidate: true })
      }

      if (
        (currentStrategyType === 'FUND' || currentStrategyType === 'AMC') &&
        structure_name !== values?.structure_name
      ) {
        setValue('structure_name', structure_name, { shouldValidate: true })
      }
    }
  }, [instrumentData])

  return instrumentDataQuery
}
